import { Colors, handleGetAgingDate, Images, isAdmin, PermissionsList, RolePermission } from 'utils';
import React from 'react';
import { DateRow, HyperLinkRow, IconAndTitle, MinLoader, PriceRow, TextRow, TextToolTip, TypeRow } from 'components';
import { Checkbox } from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { BILLED, NOT_BILLABLE } from '../../fragments/billing/billingDetails/core/constants';
import { CustomerInformation } from 'fragments';
import { customerTypeEnums } from '../customers/constants';
import { PmtDate } from './receivables/core/pmtDate';
import { GET_BILLING_GROUPS } from '../../store/loads/loads.types';
import { LoadDetailSwitcher } from '../loads';
import { reserveTabTypeEnums } from '../../fragments/carriers/carrierInfo/core/constants';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const billingsHead = [
  { name: 'loadId', searchKey: 'LOAD_DISPLAY_ID', title: 'Load ID', custom: false },
  {
    name: 'createdDate',
    title: 'Processed Date',
    icon: 'date',
    smallSize: 9,
    bigSize: 11,
    type: 'date',
    width: '120px',
  },
  { name: 'customer', searchKey: 'CUSTOMER', title: 'Customer', custom: false },
  { name: 'customerReference', title: 'Ref.', custom: false, width: '150px' },
  { name: '', nameRow: 'balance', title: 'Balance', custom: false },
  { name: 'office', nameRow: 'name', title: 'Office', custom: false },
  { name: 'mc', nameRow: 'mc', title: 'Mc', custom: false },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SUBMIT_BILL?.code]) &&
  { name: '', title: 'Action ', custom: false, width: '150px' },
];

export const billingsBody = (loadId) => [
  { rowText: (item) => <IconAndTitle icon={Images.loadOutline} title={item?.displayId} /> },
  { rowText: (item) => <DateRow date={item?.bill?.processedDate} /> },
  {
    rowText: (item) =>
      <div className="align-center" style={{ gap: 4 }}>

        {(item?.customer?.prepaid && isAdmin) &&
          <TextToolTip
            wrapperStyles={{
              width: '18px',
              minWidth: '18px',
              height: '18px',
            }}
            text={
              <div style={{ width: '100%', minWidth: '100%', height: '100%' }}>
                <img
                  src={Images.dollarSvg}
                  alt="prepaid"
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
            }
            content="Customer Prepaid"
            showTooltip
          />
        }
        <HyperLinkRow
          textWidth={10}
          name={item?.customer?.name}
          href={RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) ? `/customer/${item?.customer?.id}` : ''}
          checkPermission={item?.customer?.id ? RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) : null}
        />
      </div>,
  },
  // { rowText: (item) => <TextRow name={item?.customer?.name} textWidth={12} /> },
  { rowText: (item) => <TextRow name={item?.customerReference} textWidth={12} /> },
  { rowText: (item) => <PriceRow info={item?.bill?.totalRate - item?.bill?.totalPaid} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.office?.name}
      href={RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) ? `/office/${item?.office?.id}` : ''}
      checkPermission={item?.office?.id ? RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.office?.name} textWidth={12} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.mc?.name}
      href={RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) ? `/mc/${item?.mc?.id}` : ''}
      checkPermission={item?.mc?.id ? RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.mc?.name} textWidth={12} /> },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SUBMIT_BILL?.code]) &&
  {
    button: (fn, it) => it?.doNotBill ?
      <div className="do-not-pay-text"><p>Do not bill is ON</p></div>
      :
      <button className={'submit-button'} onClick={() => fn('submit')}>
        {loadId === it?.id ?
          <MinLoader margin={'0'} position={'relative'} color={'#fff'} />
          :
          'Submit'
        }
      </button>,
    notClickable: true,
  },
];

export const billingPrepaidHead = [
  { name: 'loadId', searchKey: 'LOAD_DISPLAY_ID', title: 'Load ID', custom: false },
  {
    name: 'createdDate',
    title: 'Created Date',
    icon: 'date',
    smallSize: 9,
    bigSize: 11,
    type: 'date',
    width: '120px',
  },
  { name: 'customer', searchKey: 'CUSTOMER', title: 'Customer', custom: false },
  { name: 'customerReference', title: 'Ref.', custom: false, width: '150px' },
  { name: '', nameRow: 'balance', title: 'Balance', custom: false },
  { name: 'office', nameRow: 'name', title: 'Office', custom: false },
  { name: 'mc', nameRow: 'mc', title: 'Mc', custom: false },
  { name: '', title: 'Billed ', custom: false, width: '90px' },
];

export const billingPrepaidBody = (loadId) => [
  { rowText: (item) =><IconAndTitle icon={Images.loadOutline} title={item?.displayIdString} />},
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  {
    rowText: (item) =>
      <div className="align-center" style={{ gap: 4 }}>

        {(item?.customer?.prepaid && isAdmin) &&
          <TextToolTip
            wrapperStyles={{
              width: '18px',
              minWidth: '18px',
              height: '18px',
            }}
            text={
              <div style={{ width: '100%', minWidth: '100%', height: '100%' }}>
                <img
                  src={Images.dollarSvg}
                  alt="prepaid"
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
            }
            content="Customer Prepaid"
            showTooltip
          />
        }
        <HyperLinkRow
          textWidth={10}
          name={item?.customer?.name}
          href={RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) ? `/customer/${item?.customer?.id}` : ''}
          checkPermission={item?.customer?.id ? RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) : null}
        />
      </div>,
  },
  // { rowText: (item) => <TextRow name={item?.customer?.name} textWidth={12} /> },
  { rowText: (item) => <TextRow name={item?.customerReference} textWidth={12} /> },
  { rowText: (item) => <PriceRow info={item?.bill?.totalRate - item?.bill?.totalPaid} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.office?.name}
      href={RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) ? `/office/${item?.office?.id}` : ''}
      checkPermission={item?.office?.id ? RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.office?.name} textWidth={12} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.mc?.name}
      href={RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) ? `/mc/${item?.mc?.id}` : ''}
      checkPermission={item?.mc?.id ? RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.mc?.name} textWidth={12} /> },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SUBMIT_BILL?.code]) &&
  {
    button: (item, info) => <div
      className="align-justify-center big-check-box">{handleBilled(item, info, loadId)}</div>,
    notClickable: true,
  },
];

const handleBilled = (item, info, loadId) => {
  const disabled = false
  return  loadId === info.id ?
    <MinLoader style={{ margin: 0, position: 'relative' }} color={Colors.ThemeBlue} />
    :
    <Checkbox
      className="big-check-box"
      disabled={disabled}
      icon={icon}
      checkedIcon={checkedIcon}
      style={{ color: disabled ? 'lightgray' : '#438AFE', padding: 0 }}
      onClick={() => !disabled && item('billed', info.id)}
      checked={!!info?.isPrepayBilled}
    />;
};


export const groupBillingsHead = [
  { name: 'loadId', searchKey: 'LOAD_DISPLAY_ID', title: 'Group Load ID', custom: false },
  { name: 'customer', searchKey: 'CUSTOMER', title: 'Customer', custom: false },
  { name: 'customerReference', title: 'Ref.', custom: false, width: '150px' },
  { name: '', nameRow: 'balance', title: 'Balance', custom: false },
  { name: 'office', nameRow: 'name', title: 'Office', custom: false },
  { name: 'mc', nameRow: 'mc', title: 'Mc', custom: false },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SUBMIT_BILL?.code]) &&
  { name: '', title: 'Action ', custom: false, width: '150px' },
];

export const groupBillingsBody = (loadId, openModals) => [
  {
    rowText: (item) => <p className="link-btn" onClick={() => openModals(item?.id, 'loadGroup')}>
      <IconAndTitle icon={Images.loadOutline} title={item?.displayId} /></p>,
  },
  {
    rowText: (item) =>
      <div className="align-center" style={{ gap: 4 }}>

        {(item?.customer?.prepaid && isAdmin) &&
          <TextToolTip
            wrapperStyles={{
              width: '18px',
              minWidth: '18px',
              height: '18px',
            }}
            text={
              <div style={{ width: '100%', minWidth: '100%', height: '100%' }}>
                <img
                  src={Images.dollarSvg}
                  alt="prepaid"
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
            }
            content="Customer Prepaid"
            showTooltip
          />
        }
        <HyperLinkRow
          textWidth={10}
          name={item?.customer?.name}
          href={RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) ? `/customer/${item?.customer?.id}` : ''}
          checkPermission={item?.customer?.id ? RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) : null}
        />
      </div>,
  },
  // { rowText: (item) => <TextRow name={item?.customer?.name} textWidth={12} /> },
  { rowText: (item) => <TextRow name={item?.customerReference} textWidth={12} /> },
  { rowText: (item) => <PriceRow info={item?.totalBillBalance} /> },
  // { rowText: (item) => <PriceRow info={item?.bill?.totalRate - item?.bill?.totalPaid} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.office?.name}
      href={RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) ? `/office/${item?.office?.id}` : ''}
      checkPermission={item?.office?.id ? RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.office?.name} textWidth={12} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.mc?.name}
      href={RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) ? `/mc/${item?.mc?.id}` : ''}
      checkPermission={item?.mc?.id ? RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.mc?.name} textWidth={12} /> },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SUBMIT_BILL?.code]) &&
  {
    button: (fn, it) => it?.doNotBill ?
      <div className="do-not-pay-text"><p>Do not bill is ON</p></div>
      :
      <button className={'submit-button'} onClick={() => fn('submit')}>
        {loadId === it?.id ?
          <MinLoader margin={'0'} position={'relative'} color={'#fff'} />
          :
          'Submit'
        }
      </button>,
    notClickable: true,
  },
];


export const groupBillingsLoadsBody = () => [
  { rowText: (item) => <IconAndTitle icon={Images.loadOutline} title={item?.displayId} /> },
  { rowText: (item) => <DateRow date={item?.bill?.processedDate} /> },
  {
    rowText: (item) =>
      <div className="align-center" style={{ gap: 4 }}>

        {(item?.customer?.prepaid && isAdmin) &&
          <TextToolTip
            wrapperStyles={{
              width: '18px',
              minWidth: '18px',
              height: '18px',
            }}
            text={
              <div style={{ width: '100%', minWidth: '100%', height: '100%' }}>
                <img
                  src={Images.dollarSvg}
                  alt="prepaid"
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
            }
            content="Customer Prepaid"
            showTooltip
          />
        }
        <HyperLinkRow
          textWidth={10}
          name={item?.customer?.name}
          href={RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) ? `/customer/${item?.customer?.id}` : ''}
          checkPermission={item?.customer?.id ? RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) : null}
        />
      </div>,
  },
  // { rowText: (item) => <TextRow name={item?.customer?.name} textWidth={12} /> },
  { rowText: (item) => <TextRow name={item?.customerReference} textWidth={12} /> },
  { rowText: (item) => <PriceRow info={item?.bill?.totalRate - item?.bill?.totalPaid} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.office?.name}
      href={RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) ? `/office/${item?.office?.id}` : ''}
      checkPermission={item?.office?.id ? RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.office?.name} textWidth={12} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.mc?.name}
      href={RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) ? `/mc/${item?.mc?.id}` : ''}
      checkPermission={item?.mc?.id ? RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.mc?.name} textWidth={12} /> },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SUBMIT_BILL?.code]) &&
  {
    button: (fn, it) =>
      it?.bill?.status === BILLABLE ?
        <button onClick={() => fn('submit')} className="request-correction-billing">
          Request Corrections
        </button>
        :
        it?.bill?.status === PAID ?
          <div className="sendTo">
            <img src={Images.greenCheckmark} alt="icon" />
            <p className="needed">Paid</p>
          </div>
          :
          it?.bill?.status === BILLED ?
            <p className="needed">Billed</p>
            :
            it?.bill?.status,
    notClickable: true,
  },
];


export const BILLING_GROUPS_ACTION_TYPE = 'GET_BILLING_GROUPS';
export const GET_BILLING_GROUP_LOADS = 'GET_BILLING_GROUP_LOADS';
export const ACTION_TYPE = 'GET_LOADS_BY_STATUS';
export const ACTION_TYPE_GET_BILLING_PREPAID_LOADS = 'GET_BILLING_PREPAID_LOADS';
export const ACTION_TYPE_SET_PREPAY_BILLED = 'SET_PREPAY_BILLED';
export const BILLABLE = 'BILLABLE';
export const RECEIVABLE = 'RECEIVABLE';
export const PAYABLE = 'PAYABLE';
export const VERIFICATION = 'PMT_VERIFICATION';
export const LOAD_VERIFICATION = 'LOAD_VERIFICATION';
export const PROCESSING = 'PROCESSING';
export const SEND_TO_BILLING = 'SEND_TO_BILLING';
export const NOT_PAYABLE = 'NOTPAYABLE';
export const NOTBILLABLE = 'NOTBILLABLE';
export const LOAD_REVISION = 'LOAD_REVISION';
export const CANCELLED = 'CANCELLED';
export const PAID = 'PAID';
export const IN_TRANSIT = 'INTRANSIT';
export const REJECTED = 'REJECTED';
export const DENIED = 'DENIED';
export const COMPLETED = 'COMPLETED';
export const PENDING = 'PENDING';
export const CREDITCHECK = 'CREDITCHECK';
export const CONSIGNMENT = 'CONSIGNMENT';
export const CONSIGNMENT_REQUEST = 'CONSIGNMENT_REQUEST';
export const ON_CLAIM = 'ON_CLAIM';
// Receivables

export const PmtPendingEnums = {
  PMT_PENDING: 'PMT_PENDING',
  NO_PMT_PENDING: 'NO_PMT_PENDING',
};
export const receivablesHead = (handleSelect, fullList, selected) => [
  {
    renderView: <Checkbox
      icon={icon}
      checkedIcon={checkedIcon}
      onClick={(e) => handleSelect(e, '', 'all')}
      name={'checkBox'}
      style={{ color: '#438AFE', padding: 0 }}
      checked={fullList?.length === selected?.length}
    />, width: '50px',
  },
  { name: 'loadId', searchKey: 'LOAD_DISPLAY_ID', title: 'Load ID', custom: false, width: '150px' },
  { name: 'bill.lastInvoiceDate', nameRow: 'lastInvoiceDate', title: 'Billed Date', icon: 'date', type: 'date' },
  { name: 'bill', nameRow: 'lastInvoiceDate', title: 'PMT Date', custom: false },
  { name: 'customerReference', searchKey: 'CUSTOMER_REF', title: 'Ref.', custom: false },
  {
    name: 'customerType', searchKey: 'CUSTOMER', title: 'Customer', width: '200px',
    filterList: [
      { name: 'All', id: '' },
      ...customerTypeEnums,
    ],
  },

  { name: 'mc', searchKey: 'MC', title: 'Authority', custom: false },
  { name: 'bill', searchKey: 'BILL_RATE', title: 'Total Billed', custom: false },
  { name: 'paid', searchKey: 'BILL_PAID', title: 'Paid Loads', custom: false, smallSize: 4 },
  {
    name: 'agingBucket', title: 'Aging',
    filterList: [
      { name: 'All', id: '' },
      { name: '0+', id: 'CURRENT' },
      { name: '30+', id: 'DUE_NOW' },
      { name: '60+', id: 'PAST_DUE' },
      { name: '90+', id: 'URGENT' },
    ],
  },
  { name: '', nameRow: 'dueDate', title: 'Due Date', custom: false, type: 'date' },
  { name: 'bill.balance', searchKey: 'BILL_BALANCE', title: 'Balance', icon: 'date', type: 'date' },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_RECEIVABLES?.code]) &&
  // { name: 'pending', title: 'Pending', custom: false , disabled: true,},
  {
    name: 'pmtPending', title: 'Pending', disabled: true,
    filterList: [
      { name: 'All', id: '' },
      { name: 'Payment Pending', id: PmtPendingEnums.PMT_PENDING },
    ], width: '140px',
  },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_RECEIVABLES?.code, PermissionsList.VERIFY_RECEIVABLES?.code]) &&
  { name: '', title: 'Verified', custom: false, width: '90px' },
];

export const renderDate = (item) => {
  const result = new Date(item?.bill?.lastInvoiceDate);
  result.setDate(result.getDate() + item?.bill?.term);
  return result;
};
export const receivablesBody = (open, currentId, handleSelect, fullList, selected, afterSuccess) => {
  return [
    {
      rowText: (item) => <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        onClick={(e) => handleSelect(e, item)}
        name={'checkBox'}
        style={{ color: '#438AFE', padding: 0 }}
        checked={selected?.includes(item?.id)}
        // checked={selected?.find((i) => (i?.id || i) === item?.id)?.id}
      />,
    },
    { rowText: (item) => <IconAndTitle icon={Images.loadOutline} title={item?.displayId} /> },
    { rowText: (item) => <DateRow date={item?.bill?.lastInvoiceDate} /> },
    { rowText: (item) => item?.bill?.lastPaidDate ? <DateRow date={item?.bill?.lastPaidDate} /> : '-' },
    { rowText: (item) => <TextRow name={item?.customerReference} textWidth={10} /> },
    {
      rowText: (item) =>
        <div
          className="modal-hyper-link"
          onClick={() => open(<CustomerInformation id={item?.customer?.id} />)}
        >
          <div className="align-center" style={{ gap: '4px' }}>
            {(item?.customer?.prepaid && isAdmin) &&
              <TextToolTip
                wrapperStyles={{
                  width: '18px',
                  minWidth: '18px',
                  height: '18px',
                }}
                text={
                  <div style={{ width: '100%', minWidth: '100%', height: '100%' }}>
                    <img
                      src={Images.dollarSvg}
                      alt="prepaid"
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                }
                content="Customer Prepaid"
                showTooltip
              />
            }
            <TextToolTip
              text={item?.customer?.name || 'Not Set'}
              content={item?.customer?.name || 'Not Set'}
              textStyles={{ color: '#438AFE' }}
            />
          </div>
        </div>,
      notClickable: true,
    },
    { rowText: (item) => <TextRow name={item?.mc?.name} textWidth={10} /> },
    { rowText: (item) => <PriceRow info={item?.bill?.totalRate} /> },
    { rowText: (item) => <PriceRow info={item?.bill?.totalPaid} /> },
    { rowText: (item) => <div>{handleGetAgingDate(item?.bill?.lastInvoiceDate)}</div>, type: 'returnColor' },
    // { rowText: (item) => <div>{handleGetDate(item?.bill?.lastInvoiceDate)}</div>, type: 'returnColor' },
    { rowText: (item) => <DateRow date={renderDate(item)} /> },
    {
      rowText: (item) => <PriceRow
        info={item?.bill?.totalRate - item?.bill?.totalPaid + (item?.bill?.corporateCharges ? item?.bill?.corporateCharges : 0)} />,
    },
    RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_RECEIVABLES?.code]) &&
    {
      rowText: (item) => <PmtDate item={item} afterSuccess={afterSuccess} />,
      // button: (item, info) => {
      //   return <div className="align-justify-center big-check-box">
      //     {currentId?.name === 'pmtPending' && currentId?.id === info?.id ?
      //       <MinLoader style={{ margin: 0, position: 'relative' }} color={Colors.ThemeBlue} />
      //       :
      //       <Checkbox
      //         icon={icon}
      //         checkedIcon={checkedIcon}
      //         style={{ color: '#438AFE', padding: 0 }}
      //         onClick={() => item('pmtPending', info.id)}
      //         checked={info?.pmtPending}
      //       />}
      //   </div>;
      // },
      notClickable: true,
    },
    RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_RECEIVABLES?.code, PermissionsList.VERIFY_RECEIVABLES?.code]) &&
    {
      button: (item, info) => <div
        className="align-justify-center big-check-box">{handleReturnCheck(item, info, currentId)}</div>,
      notClickable: true,
    },
  ];
};

const handleReturnCheck = (item, info, currentId) => {
  // const date = handleGetDate(info?.bill?.lastInvoiceDate);
  const date = handleGetAgingDate(info?.bill?.lastInvoiceDate);
  let disabled = RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.VERIFY_RECEIVABLES?.code]) ? date > 7 : true;

  return currentId?.name === 'verify' && currentId?.id === info.id ?
    <MinLoader style={{ margin: 0, position: 'relative' }} color={Colors.ThemeBlue} />
    :
    <Checkbox
      className="big-check-box"
      disabled={disabled}
      icon={icon}
      checkedIcon={checkedIcon}
      style={{ color: disabled ? 'lightgray' : '#438AFE', padding: 0 }}
      onClick={() => !disabled && item('verify', info.id)}
      checked={info?.bill?.verified}
    />;
};

// export const handleGetDate = (info) => {
//   const date1 = new Date(info);
//   const date2 = new Date();
//   const oneDay = 1000 * 60 * 60 * 24;
//   const diffInTime = date2.getTime() - date1.getTime();
//   return Math.round(diffInTime / oneDay);
// };


// export const handleGetDate = (date) => {
//   if (!date) return 0;
//
//   const dateFrom = new Date(date);
//   const dateTo = new Date();
//
//   if (isNaN(dateFrom)) return 0;
//
//   const ms1 = dateFrom.getTime();
//   const ms2 = dateTo.getTime();
//   const diff = ms2 - ms1;
//
//   return Math.ceil(diff / (1000 * 60 * 60 * 24)); // days
// };

export const processingHead = [
  { name: 'loadUd', searchKey: 'LOAD_DISPLAY_ID', title: 'Load ID', custom: false },
  { name: 'processedDate', title: 'Process. Date', icon: 'date', type: 'date', width: '140px' },
  { name: 'customer', searchKey: 'CUSTOMER', title: 'Customer', custom: false },
  { name: 'carrier', searchKey: 'CARRIER', title: 'Vendor', custom: false },
  { name: 'agent', nameRow: 'name', title: 'Agent', custom: false },
  { name: 'branch', nameRow: 'name', title: 'Branch', custom: false },
  { name: 'office', nameRow: 'name', title: 'Office', custom: false },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SEND_TO_BILLING?.code]) &&
  {
    name: '', title: 'Billing', custom: false,
    // filterList: [
    //   { name: 'All', id: '' },
    //   { name: 'Sent to Billing', id: 'billing' },
    //   { name: 'Not Sent to Billing', id: 'notBilling' },
    //   { name: 'Corrections Needed', id: 'corrections' },
    // ],
  },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SEND_TO_PAYABLE?.code]) &&
  {
    name: '', title: 'Payable', custom: false,
    // filterList: [
    //   { name: 'All', id: '' },
    //   { name: 'Sent to Payables', id: 'payables' },
    //   { name: 'Corrections Needed', id: 'needed' },
    //   { name: 'Not Sent to Payables', id: 'notPayables' },
    //   { name: 'Awaiting Verification', id: 'awaiting' },
    // ],
  },
];

export const processingBody = [
  { rowText: (item) => <div>{item?.displayId}</div> },
  { rowText: (item) => <DateRow date={item?.processedDate} /> },
  {
    rowText: (item) =>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>

        <HyperLinkRow
          name={item?.customer?.name}
          href={RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) ? `/customer/${item?.customer?.id}` : ''}
          checkPermission={item?.customer?.id ? RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) : null}
        />
        {/*<TextRow name={item?.customer?.name} textWidth={12} />*/}
        <TextToolTip
          text={item?.customerRate}
          content={item?.customerRate}
          priceRow
          textStyles={{ color: '#9C9EA9' }}
        />
      </div>,
  },
  {
    rowText: (item) =>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <HyperLinkRow
          name={item?.carrier?.name}
          href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${item?.carrier?.id}` : ''}
          checkPermission={item?.carrier?.id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
        />
        {/*<TextRow name={item?.carrier?.name} textWidth={12} />*/}
        <TextToolTip
          text={item?.payable?.totalRate}
          content={item?.payable?.totalRate}
          priceRow
          textStyles={{ color: '#9C9EA9' }}
        />
      </div>,
  },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.agent?.name}
      href={RolePermission([PermissionsList.READ_AGENT?.code, PermissionsList.CREATE_UPDATE_AGENT?.code]) ? `/agent/${item?.agent?.id}` : ''}
      checkPermission={item?.agent?.id ? RolePermission([PermissionsList.READ_AGENT?.code, PermissionsList.CREATE_UPDATE_AGENT?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.agent?.name} textWidth={12} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.branch?.name}
      href={RolePermission([PermissionsList.READ_BRANCH?.code, PermissionsList.CREATE_UPDATE_BRANCH?.code]) ? `/branch/${item?.branch?.id}` : ''}
      checkPermission={item?.branch?.id ? RolePermission([PermissionsList.READ_BRANCH?.code, PermissionsList.CREATE_UPDATE_BRANCH?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.branch?.name} textWidth={12} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.office?.name}
      href={RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) ? `/office/${item?.office?.id}` : ''}
      checkPermission={item?.office?.id ? RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.office?.name} textWidth={12} /> },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SEND_TO_BILLING?.code]) &&
  { button: (item, info, load) => renderBilling(item, info, load), notClickable: true },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SEND_TO_PAYABLE?.code]) &&
  { button: (item, info, load) => renderPayable(item, info, load), notClickable: true },
];


const renderPayable = (data, info, load) => {
  // if (info?.payable?.finalAmount <= 0) {
  //     return <p style={{color: Colors.ThemeRed}}>Balance is $0 or less</p>
  // } else {

  if (info?.payable?.status === 'PAID') {
    return <div className="sendTo">
      <img src={Images.greenCheckmark} alt="icon" />
      <p className="needed">Fully Paid</p>
    </div>;
  } else if (info?.payable?.notes && info?.payable?.status === NOT_PAYABLE) {
    return <p className="needed">Corrections Needed</p>;
  } else if (info.loadVerification === true) {
    return <p className="awaiting">Awaiting Verification</p>;
  } else if (info?.payable?.status !== NOT_PAYABLE) {
    return <div className="sendTo">
      <img src={Images.greenCheckmark} alt="icon" />
      <p className="needed">Sent to Payables</p>
    </div>;
  } else {
    return <button className="blueButton" onClick={() => data('sendToPayables')}>
      {load ?
        <MinLoader style={{ margin: 0 }} position={'relative'} color={Colors.TextWhite} />
        :
        'Send to Payable'
      }
    </button>;
  }
  // }
};

const renderBilling = (data, info, load) => {
  if (info?.status === 'PAID') {
    return <div className="sendTo">
      <img src={Images.greenCheckmark} alt="icon" />
      <p className="needed">Fully Paid</p>
    </div>;
  } else {
    if (info?.bill?.notes) {
      return <p className="needed">Corrections Needed</p>;
    } else if (info.bill?.status === NOT_BILLABLE || !info.bill?.status) {
      return <button
        onClick={() => data('sendToBilling')}
        className="blueButton">
        {load === true ?
          <MinLoader style={{ margin: 0 }} color={Colors.TextWhite} />
          :
          'Send to Billing'
        }
      </button>;
    } else {
      return <div className="sendTo">
        <img src={Images.greenCheckmark} alt="icon" />
        <p className="needed">Sent to Billing</p>
      </div>;
    }
  }
};


export const PaymentHead = [
  { name: 'loadId', searchKey: 'LOAD_DISPLAY_ID', title: 'Load ID', custom: false },
  { name: 'carrier', searchKey: 'CARRIER', title: 'Vendor', icon: 'date', custom: false },
  { name: 'payable', nameRow: 'payeeName', title: 'Payee', custom: false },
  {
    name: '', title: 'Method', custom: false,
    // filterList: [
    //     {name: 'All', id: ''},
    //     {name: 'Check', id: 'CHECK'},
    //     {name: 'Ach', id: 'ACH'},
    //     {name: 'Efs', id: 'EFS'},
    // ]
  },
  {
    name: '', title: 'Term', custom: false,
    // filterList: [
    //     {name: 'All', id: ''},
    //     {name: 'Custom Quick Pay', id: 'CUSTOM_QUICKPAY'},
    //     {name: '30 Day', id: 'THIRTYDAY'},
    //     {name: 'Quick Pay', id: 'QUICKPAY'},
    // ]
  },
  { name: '', title: 'Amount', custom: false },
  { name: '', title: 'Charges', smallSize: 6, custom: false },
  { name: '', title: 'Paid Amount', custom: false, smallSize: 6 },
  { name: '', title: 'Final Amount', custom: false, smallSize: 6 },
  { name: '', title: 'Actions', custom: false },
];

export const PaymentVBody = [
  { rowText: (item) => <div>{item?.displayId}</div> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.carrier?.name}
      href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${item?.carrier?.id}` : ''}
      checkPermission={item?.carrier?.id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.carrier?.name} textWidth={12} /> },
  { rowText: (item) => <TextRow name={item?.payable?.payeeName} textWidth={12} /> },
  { rowText: (item) => <TypeRow text={item?.payable?.pmtMethod ? item?.payable?.pmtMethod : ''} /> },
  { rowText: (item) => <TypeRow text={item?.payable?.pmtTerm ? item?.payable?.pmtTerm : ''} /> },
  { rowText: (item) => <PriceRow info={item?.carrierRate} /> },
  { rowText: (item) => <PriceRow info={item?.carrierCharges} /> },
  { rowText: (item) => <PriceRow info={item?.carrierPaid} /> },
  { rowText: (item) => <PriceRow info={item?.payable?.finalAmount} /> },
  // { rowText: (item) => <PriceRow info={item?.carrierRate - item?.carrierCharges - item?.carrierPaid} /> },
  { button: (item, info, load) => renderPaymentVerification(item, info, load), notClickable: true },
];

const renderPaymentVerification = (data, info, load) => {

  if (info?.doNotPay === true) {
    return <div className="do-not-pay-text"><p>Do not pay is ON</p></div>;
  } else {
    if (info?.payable?.finalAmount < 0) {
      return <p style={{ color: Colors.ThemeRed }}>Carrier is negative</p>;
    } else {
      return <div style={{ display: 'flex' }}>
        {info?.carrier?.debt?.length > 0 && info?.carrier?.outstandingDebt > 0 ?
          <button
            style={{ width: '70px', marginRight: '16px' }}
            onClick={() => data('COLLECT')}
            className="blue-button"
          >
            Collect
          </button>
          : ''}
        <button
          style={{ width: '80px', background: Colors.ThemeGreen }}
          onClick={() => data('APPROVE')}
          className="blue-button"
        >
          {load ?
            <MinLoader position={'relative'} style={{ margin: 0 }} color={'white'} />
            :
            'Approve'
          }
        </button>
      </div>;
    }
  }
};

export const LoadVerificationHead = [
  { name: 'loadId', searchKey: 'LOAD_DISPLAY_ID', title: 'Load ID', custom: false },
  { name: 'createdDate', title: 'Created Date', icon: 'date', type: 'date', width: '130px' },
  { name: 'customer', searchKey: 'CUSTOMER', title: 'Customer', custom: false },
  { name: 'carrier', searchKey: 'CARRIER', title: 'Vendor', custom: false },
  { name: 'agent', nameRow: 'name', title: 'Agent', custom: false },
  { name: 'office', nameRow: 'name', title: 'Office', custom: false },
  { name: 'instructions', title: 'Note', custom: false },
];

export const LoadVerificationBody = [
  { rowText: (item) => <TextRow name={item?.displayId} textWidth={12} /> },
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.customer?.name}
      href={RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) ? `/customer/${item?.customer?.id}` : ''}
      checkPermission={item?.customer?.id ? RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.customer?.name} textWidth={12} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.carrier?.name}
      href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${item?.carrier?.id}` : ''}
      checkPermission={item?.carrier?.id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.carrier?.name} textWidth={12} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.agent?.name}
      href={RolePermission([PermissionsList.READ_AGENT?.code, PermissionsList.CREATE_UPDATE_AGENT?.code]) ? `/agent/${item?.agent?.id}` : ''}
      checkPermission={item?.agent?.id ? RolePermission([PermissionsList.READ_AGENT?.code, PermissionsList.CREATE_UPDATE_AGENT?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.agent?.name} textWidth={12} /> },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.office?.name}
      href={RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) ? `/office/${item?.office?.id}` : ''}
      checkPermission={item?.office?.id ? RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code]) : null}
    />,
  },
  // { rowText: (item) => <TextRow name={item?.office?.name} textWidth={12} /> },
  { rowText: (item) => <TextRow name={item?.instructions} textWidth={12} /> },
];

export const receivablesCsv = {
  type: 'receivables',
  statusEnum: 'department',
};


export const vendorsReserveHead = [
  { name: 'companyName', title: 'Vendor Name', custom: false },
  { name: 'reserve', nameRow: 'keptAmount', title: 'Reserve', custom: false },
  { name: 'reserve', nameRow: 'chargedAmount', title: 'Reserve used', custom: false },
];

export const vendorsReserveBody = [
  {
    rowText: (item) => <HyperLinkRow
      name={item?.companyName}
      href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${item?.id}` : ''}
      checkPermission={item?.id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
    />,
    // <TextRow name={item?.companyName} />
  },
  { rowText: (item) => <PriceRow info={item?.reserve?.keptAmount} /> },
  { rowText: (item) => <PriceRow info={item?.reserve?.chargedAmount} /> },
];


export const factoredVendorsReserveHead = (viewType) => [
  { name: '', title: 'Date', custom: false },
  { name: 'displayId', searchKey: 'LOAD_DISPLAY_ID', title: 'Load ID', custom: false },
  { name: 'customer', nameRow: 'name', title: 'Customer', custom: false },
  { name: 'bill.lastPaidDate', title: 'Last Paid Date', icon: 'date', smallSize: 6, type: 'date', width: '90px' },

  viewType === reserveTabTypeEnums.PAID &&
  { name: 'bill.lastPaidDate', title: 'Collected for load', custom: false,  width: '100px' },

  { name: '', title: 'Reserve %', custom: false },
  { name: '', title: 'Reserve Kept', custom: false },
  { name: '', title: 'Reserve Used', custom: false },
  { name: '', title: viewType === reserveTabTypeEnums.PAID? 'Reserve Paid' : 'Reserve Released', custom: false },
  // { name: '', title: 'Balance', custom: false },
];

export const factoredVendorsReserveBody = (viewType) => [
  { rowText: (item) => <DateRow date={item?.createdAt} /> },
  { rowText: (item) => <TextRow name={item?.displayId} /> },
  { rowText: (item) => <TextRow name={item?.customer?.name} /> },
  { rowText: (item) => <DateRow date={item?.bill?.lastPaidDate} />, },

  viewType === reserveTabTypeEnums.PAID &&
  { rowText: (item) => <div>{ item?.payable.carrierReserve.collectForLoads?.length ?
      <TextRow name={`${item?.payable.carrierReserve.collectForLoads?.map((i) => i?.displayIdString)?.join(', ')}`}/>
      : 'N/A'}</div>,
  },

  { rowText: (item) => <p>%{item?.payable?.carrierReserve?.percent || 0}</p> },
  { rowText: (item) => <PriceRow info={item?.payable?.carrierReserve?.keptAmount} />, },
  { rowText: (item) => <PriceRow info={item?.payable?.carrierReserve?.chargedAmount} /> },
  { rowText: (item) => <PriceRow info={item?.payable?.carrierReserve?.releasedAmount} /> },
  // { rowText: (item) => <PriceRow info={item?.payable?.carrierReserve?.keptAmount} /> },
];


export const VENDORS_RESERVE_ACTION_TYPE = 'GET_ALL_RESERVES';
export const GET_RESERVE = 'GET_RESERVE';


export const shortOverpayHead = [
  { name: 'loadId', searchKey: 'LOAD_DISPLAY_ID', title: 'Load ID', custom: false },
  { name: 'billedDate', title: 'Billed Date', custom: false, disabled: true },
  { name: 'loadDate', title: 'Load Date', custom: false, disabled: true },
  { name: 'customer', searchKey: 'CUSTOMER_REF', title: 'Customer ', custom: false },
  { name: '', title: 'Office/Agent ', custom: false },
  { name: '', title: 'Total Billed ', custom: false },
  { name: '', title: 'Total Paid ', custom: false },
  { name: '', title: 'Credit ', custom: false },
  { name: '', title: 'Short Pay ', custom: false },
  { name: '', title: 'Aply to', custom: false },
];

const applyToEnums = {
  AGENT: 'AGENT',
  VENDOR: 'VENDOR',
  CORPORATE: 'CORPORATE',
};
export const shortOverpayBody = (openPrimary) => [
  {
    rowText: (item) => <div onClick={() => openPrimary(<LoadDetailSwitcher loadId={item?.id} />)}
                            className="link-btn">{item?.displayId}</div>,
  },
  { rowText: (item) => <DateRow date={item?.bill?.lastInvoiceDate} /> },
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  {
    rowText: (item) => <div>
      <TextRow name={item?.customer?.name ? item?.customer?.name : ''} />
      <TextRow color="rgb(156, 158, 169)" name={item?.customerReference ? item?.customerReference : ''} />
    </div>,
  },
  {
    rowText: (item) => <div>
      <TextRow name={item?.office?.name ? item?.office?.name : ''} />
      <TextRow color="rgb(156, 158, 169)" name={item?.agent?.name ? item?.agent?.name : ''} />
    </div>,
  },
  { rowText: (item) => <PriceRow info={item?.bill?.balance + item?.bill?.totalPaid} /> },
  { rowText: (item) => <PriceRow info={item?.bill?.totalPaid} /> },
  {
    rowText: (item) => <p className="credit-type"><PriceRow info={item?.bill?.balance < 0 ? -item?.bill?.balance : 0} />
    </p>,
  },
  {
    rowText: (item) => <p className="short-pay-type"><PriceRow
      info={item?.bill?.balance > 0 ? item?.bill?.balance : 0} /></p>,
  },
  {
    button: (fn, info, load) => {
      return <div className="flex-align-center" style={{ gap: 10 }}>
        {!info?.isFactored &&
          <button disabled={load} style={{ opacity: load ? 0.5 : 1, width: 90 }} className="apply-to-btn"
                  onClick={() => fn(applyToEnums?.AGENT)}>
            {load ?
              <MinLoader margin={'0'} position={'relative'} color={'#438AFE'} />
              :
              'Agent'
            }</button>
        }
        <button disabled={load} style={{ opacity: load ? 0.5 : 1, width: 110 }} className="apply-to-btn"
                onClick={() => fn(applyToEnums?.CORPORATE)}>
          {load ?
            <MinLoader margin={'0'} position={'relative'} color={'#438AFE'} />
            :
            'Corporate'
          }
        </button>
        <button disabled={load} style={{ opacity: load ? 0.5 : 1, width: 100 }} className="apply-to-btn"
                onClick={() => fn(applyToEnums?.VENDOR)}>
          {load ?
            <MinLoader margin={'0'} position={'relative'} color={'#438AFE'} />
            :
            'Vendor'
          }
        </button>
      </div>;
    }, notClickable: true,
  },
];

export const SHORT_OVERPAY_ACTION_TYPE = 'GET_SHORT_OVERPAYS';